module.exports = __webpack_public_path__ + "static/img/lxy_ani_02_apng.14daef9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/springFestival/lxy_ani_02_apng.png
// module id = P7vK
// module chunks = 5